<template>
  <div class="p-contentplans-writing-serps-titles">
    <div class="p-contentplans-writing-serps-titles__header">
      <h4 class="p-contentplans-writing__title--sub">
        上位ページのタイトル・ディスクリプション・見出しテキスト
      </h4>
      <ButtonDownloadSerpsTitles
        :createdAt="createdAt"
        :keyword="keyword"
        :project="project"
        :isCompleteData="isCompleteData"
        :isCompleteSomeData="isCompleteSomeData"
      />
    </div>
    <Advice v-if="isError" img="error" priority="low-gray">
      <template slot="title">
        <p>データが取得できませんでした。</p>
      </template>
      <p>
        時間を置いても取得できない場合は、チャットにてお問い合わせください。
      </p>
    </Advice>
    <Advice
      v-else-if="!isSerpsLoading && !serpsTopItems.length"
      img="error"
      priority="low-gray"
    >
      <template slot="title">
        調査したいキーワードではGoogleの検索結果が0件でした。
      </template>
      <p>
        実際の検索結果が0件ではない場合は、チャットにてお問い合わせください。
      </p>
    </Advice>
    <LoadingChara v-else-if="isLoading" variant="inline" size="sm">
      <template slot="title">データ取得中</template>
    </LoadingChara>
    <div v-else class="p-contentplans-writing-serps-titles-list">
      <SerpsTitlesListItem
        v-for="(item, index) in data.items"
        :key="index"
        :errorAddHeading="errorAddHeading"
        :item="item"
        :index="index"
        :project="project"
        :isEditMode="isEditMode"
        @addHeading="addHeading"
      />
    </div>
  </div>
</template>

<script>
import Advice from '@/components/Advice';
import ButtonDownloadSerpsTitles from '@/components/contentPlans/ButtonDownloadSerpsTitles';
import SerpsTitlesListItem from '@/components/contentPlans/writing/SerpsTitlesListItem';
import LoadingChara from '@/components/LoadingChara';
import apiIntents from '@/api/intents';
import apiProjects from '@/api/projects';
import axios from 'axios';
import utils from '@/utils';

export default {
  props: [
    'createdAt',
    'errorAddHeading',
    'keyword',
    'project',
    'serpsTopItems',
    'serpsAllItems',
    'isEditMode',
    'isSerpsError',
    'isSerpsLoading'
  ],
  components: {
    Advice,
    ButtonDownloadSerpsTitles,
    SerpsTitlesListItem,
    LoadingChara
  },
  data() {
    return {
      expiresAt: Date.now() + 10 * 60 * 1000,
      data: {
        items: []
      },
      isCompleteData: false,
      isCompleteSomeData: false,
      isLoading: true,
      timeout: null,
      return: [],
      flg: true
    };
  },
  computed: {
    isError() {
      return this.isSerpsError;
    }
  },
  watch: {
    serpsTopItems: {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true
    }
  },
  destroyed() {
    clearTimeout(this.timeout);

    // 非同期通信をキャンセル
    this.flg = false;
    for (let i = 0; i < this.return.length; i++) {
      if (this.return[i]) {
        this.return[i].cancel();
      }
    }
  },
  methods: {
    addHeading(level, value) {
      this.$emit('addHeading', level, value);
    },
    init() {
      if (!this.serpsTopItems.length) {
        return;
      }
      // 配列のコピー
      this.data.items = JSON.parse(JSON.stringify(this.serpsTopItems));

      for (let i = 0; i < this.data.items.length; i++) {
        if (this.data.items[i].url.indexOf(this.project.siteUrl) !== -1) {
          this.data.items[i].isOwnSite = true;
        } else {
          this.data.items[i].isOwnSite = false;
        }
      }

      // 10位までに登録サイトがない場合は追加
      if (!this.data.items.some(item => item.isOwnSite)) {
        this.data.items.unshift({
          url: null,
          rank: null,
          isOwnSite: true
        });
      }

      this.data.items = this.data.items.map((item, index) => {
        // 11位以下の自社サイトURLとrankの取得
        if (!item.rank) {
          for (let i = 0; i < this.serpsAllItems.length; i++) {
            if (
              this.serpsAllItems[i].url.indexOf(this.project.siteUrl) !== -1
            ) {
              item.url = this.serpsAllItems[i].url;
              item.rank = this.serpsAllItems[i].rank;
              break;
            }
          }
        }

        item.description = null;
        item.title = null;
        item.headerStructures = null;
        item.headers = {
          h1: null,
          h2: null,
          h3: null,
          h4: null,
          h5: null
        };

        return item;
      });

      for (let i = 0; i < this.data.items.length; i++) {
        this.getContentPlansTitle(this.data.items[i], i);
      }
    },
    getContentPlansTitle(item, index) {
      // 圏外の場合はユーザーに見れないことを伝える
      if (!item.rank) {
        return;
      }
      // URLの接尾辞が.pdfの場合はTDHの内容が表示できないため、
      // ユーザーに見れないことを伝える
      if (item.url && utils.isPdf(item.url)) {
        let obj = Object.assign({}, this.data.items[index]);
        obj.description = '';
        obj.title = '';
        obj.headers = {
          h1: [],
          h2: [],
          h3: [],
          h4: [],
          h5: []
        };
        obj.contentType = 'pdf';
        obj.isOwnSite = item.isOwnSite;
        // ローディング無効
        this.isLoading = false;
        this.data.items.splice(index, 1, obj);
        return;
      }

      let params = {
        dateJst: this.$options.filters.dateText(this.createdAt, 'YYYY-MM-DD'),
        device: 'desktop',
        url: item.url,
        resource: 'all'
      };
      this.return[index] = axios.CancelToken.source();

      return apiProjects.contentPlans.tdh
        .get(
          params,
          this.auth.idToken,
          this.project.id,
          this.return[index].token,
          index + 1
        )
        .then(response => {
          let obj = Object.assign({}, this.data.items[index]);
          obj.description = response.data.description;
          obj.title = response.data.title;
          obj.headers = {
            h1: response.data.headers.h1,
            h2: response.data.headers.h2,
            h3: response.data.headers.h3,
            h4: response.data.headers.h4,
            h5: response.data.headers.h5
          };
          obj.contentType = 'html';
          obj.isOwnSite = item.isOwnSite;

          // hタグの構造データを持っていないtdhデータも存在する（旧仕様での取得データ
          if (response.data.headerStructures) {
            obj.headerStructures = response.data.headerStructures;
          }

          this.data.items.splice(index, 1, obj);

          // インテントが取得できていない && タイトルの情報がある場合のみインテントを取得する
          if (!this.data.items[index].intent && response.data.title) {
            this.getIntent(response.data.title, index);
          }
          this.scheduleGetTitles(item, index);

          // 圏外とpdf以外の場合はtitleとdescriptionとheaderStructuresがあること
          this.isCompleteData = this.data.items.every(item => {
            return this.isLoadedTdhItem(item);
          });
          // 1件でもデータが取得できてればtrue
          this.isCompleteSomeData = this.data.items.some(item => {
            return this.isNotBlankTdhItem(item);
          });
          this.isLoading = false;
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            this.scheduleGetTitles(item, index);
          }
        });
    },
    getIntent(word, index) {
      let params = {
        word: word
      };
      return apiIntents
        .get(params, this.auth.idToken, null, index + 1)
        .then(response => {
          let obj = Object.assign({}, this.data.items[index]);
          obj.intent = response.data;
          this.data.items.splice(index, 1, obj);
          this.isLoading = false;
        })
        .catch(error => {});
    },
    scheduleGetTitles(item, index) {
      if (this.flg) {
        if (Date.now() < this.expiresAt) {
          this.timeout = setTimeout(() => {
            this.getContentPlansTitle(item, index);
          }, 30000);
        } else {
          this.isLoading = false;
          if (this.data.items) {
            for (let i = 0; i < this.data.items.length; i++) {
              const item = this.data.items[index];
              this.data.items.splice(index, 1, {
                ...item,
                description:
                  item.description === null ? undefined : item.description,
                title: item.title === null ? undefined : item.title
              });
            }
          }
        }
      }
    },
    isLoadedTdhItem(item) {
      return (
        item.rank === null ||
        item.contentType === 'pdf' ||
        (item.title !== null &&
          item.description !== null &&
          item.headerStructures !== undefined)
      );
    },
    isNotBlankTdhItem(item) {
      return (
        item.title ||
        item.description ||
        (item.headerStructures && item.headerStructures.length)
      );
    }
  }
};
</script>
